import {IoIosEye} from 'react-icons/io';
import { FaGithub } from "react-icons/fa";

export const Project = [
    // StudyNotion
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1718986836/Portfolio%20Images/Study%20Notion.png",
      name: "studyNotion",
      description : "An Educational Technology platform built with React, Redux, Node.js, and MongoDB. Supports 100+ users with course publishing, Razorpay processing, and role-based auth.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://studynotion.codewithrizwan.in/",
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Study-Notion"
        },
      ]
    },

    // Confessly
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1724149268/Portfolio%20Images/Confessly.png",
      name : "Confessly",
      description : "AI-Powered Anonymous Messaging built with Next.js, TypeScript, NextAuth, and Zod. Features Gemini AI prompt generation and fully encrypted message workflows.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://confessly.codewithrizwan.in/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Confessly"
        },
      ]
    },

    // Top-Courses
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1727711390/Top-Courses-Rizwan.png",
      name : "Top Courses",
      description : "A course catalog built using React.js where users can interact with course cards by liking or disliking them.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://top-courses-rizwan.vercel.app/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Top-Courses"
        },
      ]
    },

    // Dev-detective-project
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1718986294/Portfolio%20Images/Dev%20Detective-Project.png",
      name : "Dev-detective-project",
      description : "Fetches and displays GitHub data, offering a user-friendly interface for exploring repositories and users using API integration.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://dev-detective-project-rizwan.netlify.app/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Dev-detective-project"
        },
      ]
    },

    // Random Password Generator
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1727710576/Random_Password_Generator_edsxhl.png",
      name : "Random Password Generator",
      description : "This web application provides a simple and efficient way to generate strong and secure passwords with just a click.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://rizwan0713.github.io/Password-Generator-/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Password-Generator-"
        },
      ]
    },
    
    // Weather App
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1718986949/Portfolio%20Images/Weather%20App.png",
      name : "Weather App",
      description : "Enables users to fetch the real-time weather condition of any location with the help of REST API integrations.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://weather-app-rizwan.netlify.app/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Weather-App"
        },
      ]
    },

    // Razorpay
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1718987036/Portfolio%20Images/Razorpay.png",
      name : "Razorpay UI Clone",
      description : "Focus on frontend (UI) designing and make websites attractive with Animations.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://razorpay-clone-website.netlify.app/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Razorpay-Clone-Website"
        },
      ]
    },

    // Tic Tac Toe Game
    {
      image : "https://res.cloudinary.com/mohdrizwan/image/upload/v1727710778/Screenshot_2024-09-30_210923_l2wj03.png",
      name : "Tic Tac Toe Game",
      description : "This project is a simple implementation of the classic Tic Tac Toe game incorporating game logic.",
      array : [
        {
          icon : <IoIosEye/>,
          link : "https://tic-tac-toe-rizwan.netlify.app/"
        },
        {
          icon : <FaGithub/>,
          link : "https://github.com/rizwan0713/Tic-Tac-Toe"
        },
      ]
    },
];